export default __webpack_public_path__ + "static/media/berraksu7.0be6c1c4.jpg";